import React from 'react';
import { Form, Input, Select } from 'antd';
import { KoButton, KoNano } from 'packages';
import KoIcon from '@kwapio/icons';
import styles from './currentProperties.module.scss';

const dataTypes = ['text', 'number', 'date', 'options', 'attachment'];

const ColumnList = () => {
  return (
    <Form.List name={["options"]} initialValue={[]}>
      {(fields, { add, remove, move }) => (
        <>
          <div className={styles.list}>
            {(fields || []).map((field, index) => (
              <div key={field.key} className={styles.listItemTable}>
                <Form.Item
                  name={[field.name, 'title']}
                  rules={[{ required: true, message: 'Enter column title' }]}
                >
                  <Input placeholder="Column Title" />
                </Form.Item>
                <Form.Item
                  name={[field.name, 'widget']}
                  rules={[{ required: true, message: 'Select column type' }]}
                >
                  <Select placeholder="Select Type">
                    {dataTypes.map(dt => (
                      <Select.Option key={dt} value={dt}>
                        {dt}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <div className={styles.actionsBtn}>
                  <KoButton icon={<KoIcon width={12} height={12} name="ArrowLineUpOutlined" />} onClick={() => move(index, index - 1)} disabled={index === 0} />
                  <KoButton icon={<KoIcon width={12} height={12} name="ArrowLineDownOutlined" />} onClick={() => move(index, index + 1)} disabled={index === fields.length - 1} />
                  <KoButton icon={<KoIcon width={12} height={12} name="DeleteOutlined" />} onClick={() => remove(field.name)} />
                </div>
              </div>
            ))}
          </div>

          <KoButton
            type="primary"
            label="Add Column"
            icon={<KoIcon name="PlusOutlined" color="#FFF" />}
            onClick={() => add({ title: '', dataIndex: KoNano('col'), widget: 'text' })}
          />
        </>
      )}
    </Form.List>
  );
};

export default ColumnList;
